import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
/** @jsx $jsx */
import { $jsx } from 'framework7';
import language from '../../../js/stores/language.js';
import * as fabric from 'fabric';
import * as dayjs from 'dayjs';
import '../../../css/user-sign-area.css';
var UserSignArea = function UserSignArea(props, _ref) {
  var $h = _ref.$h,
    $update = _ref.$update,
    $onMounted = _ref.$onMounted,
    $emit = _ref.$emit;
  var locale = language.getters.Item.value;
  var canvas = null;
  $onMounted(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    return _regeneratorRuntime.wrap(function (_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          setTimeout(function () {
            createSignArea();
          }, 500);
          $update();
        case 1:
        case "end":
          return _context.stop();
      }
    }, _callee);
  })));
  var createSignArea = function createSignArea() {
    canvas = new fabric.Canvas("".concat(props.prefixArea, "-sheet"));
    canvas.isDrawingMode = true;
    canvas.freeDrawingBrush = new fabric.PencilBrush(canvas, {
      width: 1,
      color: '#DDDDDD',
      opacity: 1
    });
    setDefaultDataOnSignArea();
    canvas.on('path:created', function (event) {
      var dataURL = canvas.toDataURL({
        format: 'png',
        quality: 1.0
      });
      $emit('checkSignedImage', dataURL);
    });
  };
  var setDefaultDataOnSignArea = function setDefaultDataOnSignArea() {
    var signerName = new fabric.Textbox("".concat(props.userFirstName, " ").concat(props.userLastName), {
      left: 10,
      top: 150,
      width: 250,
      fontSize: 14
    });
    var currentDayTime = dayjs().format('YYYY-MM-DD HH:mm');
    var signDataTime = new fabric.Textbox("".concat(currentDayTime), {
      left: 10,
      top: 165,
      width: 150,
      fontSize: 14
    });
    canvas.add(signerName, signDataTime);
  };
  var clearSignArea = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      return _regeneratorRuntime.wrap(function (_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            canvas.clear();
            setDefaultDataOnSignArea();
            $emit('checkSignedImage', null);
          case 1:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return function clearSignArea() {
      return _ref3.apply(this, arguments);
    };
  }();
  return function ($ctx) {
      var $ = $ctx.$;
      var $h = $ctx.$h;
      var $root = $ctx.$root;
      var $f7 = $ctx.$f7;
      var $f7route = $ctx.$f7route;
      var $f7router = $ctx.$f7router;
      var $theme = $ctx.$theme;
      var $update = $ctx.$update;
      var $store = $ctx.$store;

      return $h`
<div class="block block-strong">
  <div class="block-title">${locale.translate('loan.signImage.title')}</div>
  <div class="set-together">
    <div class="sheet-container">
      <canvas id="${props.prefixArea}-sheet" width="300" height="200"></canvas>
    </div>
  </div>
  <p class="grid grid-cols-3 xlarge-grid-cols-3">
    <div></div>
    <div>
      <a href="#" class="button button-small button-fill button-raised color-red" @click="${clearSignArea}">
        <span class="material-symbols-outlined">delete</span>${locale.translate('general.clear')}
      </a>
    </div>
    <div></div>
  </p>
</div>
`
    }
    ;
};
//Export component name
export default UserSignArea;

//On template use:
//<${UserSignArea} user-first-name="Lender Name" user-last-name="Last Name" prefix-area="pre" />